import React from 'react';
import { MAIN_MOCKUP } from '../data/content';
const particles = Array.from({
  length: 14
}).map((_, i) => ({
  left: `${(i * 7 + i % 3 * 9) % 96}%`,
  duration: `${9 + i % 5 * 2.5}s`,
  delay: `${i % 7 * 1.4}s`,
  size: i % 4 === 0 ? 4 : 2.5,
  opacity: i % 3 === 0 ? 0.9 : 0.55
}));
export function Hero() {
  return <header className="relative vignette overflow-hidden bg-night px-5 pb-6 pt-8 flex flex-col" data-id="element-57" data-mp="4mrtszj81xkp">
      <div aria-hidden="true" className="absolute inset-0 overflow-hidden" data-id="element-58" data-mp="128fs5pz8mpyv">
        {particles.map((p, i) => <span key={i} className="particle" style={{
        left: p.left,
        width: p.size,
        height: p.size,
        opacity: p.opacity,
        animationDuration: p.duration,
        animationDelay: p.delay
      }} data-id="element-59" data-mp="xbfi73z9p32h" data-mpi={i} />)}
      </div>

      <div className="relative z-10 flex flex-col items-center" data-id="element-60" data-mp="neklmqmk1cqu">
        <h1 className="font-display text-[32px] leading-[1.15] font-bold uppercase text-center text-gold-gradient" data-id="element-61" data-mp="3d33h34xud5nx">
          Convertí un mate común, en un momento de bienestar 
en solo 5 minutos !!!
        </h1>

        <img id="mockup-principal" src={MAIN_MOCKUP} alt="Ebook El Secreto del Mate Perfecto" loading="eager" decoding="async" fetchPriority="high" width={320} height={217} className="mt-4 w-full max-w-[320px] h-auto rounded-md drop-shadow-[0_20px_60px_rgba(201,168,76,0.35)]" data-id="element-62" data-mp="3j9afx9oryk3k" />
      </div>

      <div className="relative z-10 mt-6 divider-gold" data-id="element-63" data-mp="3e7uzjuxjl1ri" />
    </header>;
}